"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _descriptionTable = require("./descriptionTable");

/**
 * @file serializeScheme.ts 调用scheme
 * @author wangning25 <wangning25@baidu.com> on 2021/10/06.
 */

/**
 * 序列化scheme
 * @param parsedScheme scheme重要元素
 * @returns {string} scheme string
 */
var serializeScheme = function serializeScheme(parsedScheme) {
  var _context, _context2, _context3, _context4, _context5;

  if (!(parsedScheme.params || {}).__skipCheck) {
    // 单测后面再补吧...
    var _checkParamsCorrect = (0, _descriptionTable.checkParamsCorrect)(parsedScheme),
        succeess = _checkParamsCorrect.succeess,
        useParams = _checkParamsCorrect.useParams;

    console.log(parsedScheme.subModuleName + '.' + parsedScheme.actionName, succeess ? '校验通过' : '校验失败', 'schemeParamsIsCorrect'); // return succeess || '';
  }

  return (0, _concat.default)(_context = (0, _concat.default)(_context2 = (0, _concat.default)(_context3 = (0, _concat.default)(_context4 = (0, _concat.default)(_context5 = "".concat(parsedScheme.protocol)).call(_context5, parsedScheme.moduleName, "/")).call(_context4, parsedScheme.subModuleName, "/")).call(_context3, parsedScheme.actionName, "?params=")).call(_context2, encodeURIComponent((0, _stringify.default)(parsedScheme.params || {})), "&callback=")).call(_context, parsedScheme.callbackName);
};

var _default = serializeScheme;
exports.default = _default;